<template>
  <div id="sma-natcon-payment-create">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <!-- Hero Header Section -->
    <v-card class="hero-card elevation-0 mb-6 animate-fade-in">
      <div class="hero-gradient-jci">
        <v-container>
          <v-row align="center" justify="space-between">
            <v-col cols="12" md="8" class="py-8">
              <div class="d-flex align-center animate-slide-right">
                <div class="hero-icon-box-jci mr-4">
                  <v-icon size="64" color="#EDBE38" class="hero-icon-animated">mdi-calendar-account</v-icon>
                </div>
                <div>
                  <h1 class="hero-title-jci white--text mb-2">
                    {{ PageTitle }}
                  </h1>
                  <p class="hero-subtitle-jci white--text mb-0">
                    {{ PageDescription }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="py-8 text-md-right text-center animate-slide-left">
              <v-btn
                @click.prevent="goBack"
                color="#56BDA3"
                large
                class="hero-action-btn-jci mr-3"
              >
                <v-icon left color="white">mdi-arrow-left</v-icon>
                <span style="color: white; font-weight: 600;">BACK</span>
              </v-btn>
              <v-btn
                @click.prevent="refreshPageData"
                color="#EDBE38"
                large
                class="hero-action-btn-jci"
              >
                <v-icon left color="#0A0F29">mdi-refresh</v-icon>
                <span style="color: #0A0F29; font-weight: 600;">REFRESH</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>

    <v-container>
      <!-- Important Notes Alert -->
      <v-alert
        v-if="NotesFlag"
        border="left"
        colored-border
        color="#0097D7"
        elevation="2"
        class="mb-6 jci-alert animate-fade-in"
        prominent
      >
        <div class="d-flex align-start">
          <v-icon large class="mr-3" color="#0097D7">mdi-information-outline</v-icon>
          <div>
            <h3 class="mb-3" style="color: #0A0F29;">Important Information</h3>
            <ol class="pl-4">
              <li class="mb-2">Regular subscription can be paid only once.</li>
              <li class="mb-2">
                After paying regular subscription, choose additional
                subscription.
              </li>
              <li class="mb-2">
                Late fee is optional but paying late fee is required to get
                voting rights.
              </li>
              <li class="mb-2">
                After completing the payment, kindly select your members for
                whom the payment was made.
              </li>
            </ol>
          </div>
        </div>
      </v-alert>

      <!-- Main Content Card -->
      <v-card class="main-card-jci elevation-4 animate-scale-up" rounded="lg">
        <v-card-text class="pa-6">
          <div class="required-note-jci mb-6">
            <v-icon small color="#EDBE38">mdi-asterisk</v-icon>
            <span class="ml-1 text-caption" style="color: #414042;">indicates required field</span>
          </div>
          <!-- Loading State -->
          <div class="d-flex justify-center mb-6" v-if="LoadingFlag">
            <v-progress-circular
              indeterminate
              color="primary"
              size="64"
            ></v-progress-circular>
          </div>

          <!-- Skeleton Loader -->
          <v-container v-if="StartupLoadingFlag">
            <v-row>
              <v-col cols="12" md="4" v-for="n in 6" :key="n">
                <v-skeleton-loader
                  type="article"
                  elevation="2"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-container>
          <!-- Main Form Content -->
          <v-container v-if="!StartupLoadingFlag" class="px-0">
            <!-- Registration Form -->
            <v-form ref="form2" v-model="valid1" lazy-validation>
              <!-- Registration Type and Member Selection Card -->
              <v-card class="info-card mb-6" elevation="2" rounded="lg">
                <v-card-title class="card-header primary white--text">
                  <v-icon left color="white">mdi-clipboard-text</v-icon>
                  Registration Details
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12" md="4">
                      <label class="field-label">
                        <span class="error--text">*</span> Member Type
                      </label>
                      <v-select
                        v-model="MemberType"
                        :items="MemberTypeOptions"
                        :rules="MemberTypeRules"
                        required
                        outlined
                        dense
                        prepend-inner-icon="mdi-account-check"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="8" v-if="MemberType == 2">
                      <label class="field-label">
                        <span class="error--text">*</span> Select Member
                      </label>
                      <v-autocomplete
                        @change="getSelectedMemberDetails"
                        :loading="MemberIdOptionsLoading"
                        :items="MemberIdOptions"
                        :rules="MemberIdRules"
                        v-model="MemberId"
                        required
                        outlined
                        dense
                        clearable
                        prepend-inner-icon="mdi-account-search"
                      >
                        <template v-slot:selection="{ item }">
                          <v-avatar size="40" class="mr-2">
                            <img :src="item.photo" />
                          </v-avatar>
                          {{ item.text }}
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar>
                            <img :src="item.photo" />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              item.text
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{
                              item.membership_id
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Member Information Card -->
              <v-row
                class="mb-6"
                v-if="
                  MemberType != '' && Object.keys(selectedMember).length > 0
                "
              >
                <v-col cols="12" md="4">
                  <v-card class="info-card h-100" elevation="2" rounded="lg">
                    <v-card-title class="card-header info white--text">
                      <v-icon left color="white">mdi-account-circle</v-icon>
                      {{ RegisterDetailsTxt }}
                    </v-card-title>
                    <v-card-text class="pa-4 text-center">
                      <v-avatar size="120" class="mb-3 elevation-3">
                        <v-img
                          :src="selectedMember.MemberImagePath"
                          :alt="selectedMember.MemberName"
                          lazy-src="/no-image-available.png"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                      <div class="font-weight-bold mb-2 text-h6">
                        {{ selectedMember.MemberName }}
                      </div>
                      <v-chip small color="primary" text-color="white">
                        {{ selectedMember.MembershipId }}
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" md="8">
                  <v-card class="info-card h-100" elevation="2" rounded="lg">
                    <v-card-title class="card-header primary white--text">
                      <v-icon left color="white">mdi-phone-message</v-icon>
                      Contact Information
                    </v-card-title>
                    <v-card-text class="pa-6">
                      <v-row>
                        <v-col cols="12" md="6">
                          <label class="field-label">
                            <span class="error--text">*</span> Email Address
                          </label>
                          <v-text-field
                            v-model="selectedMember.EmailId"
                            :rules="EmailIdRules"
                            outlined
                            dense
                            prepend-inner-icon="mdi-email"
                            placeholder="Enter email address"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <label class="field-label">
                            <span class="error--text">*</span> Phone Number
                          </label>
                          <v-text-field
                            v-model="selectedMember.MobileNo"
                            :rules="MobileNoRules"
                            :counter="10"
                            v-mask="'##########'"
                            outlined
                            dense
                            prepend-inner-icon="mdi-phone"
                            placeholder="Enter phone number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Non-Member Participants Card -->
              <v-card
                class="info-card mb-6"
                elevation="2"
                rounded="lg"
                v-if="MemberType == 3"
              >
                <v-card-title class="card-header warning white--text">
                  <v-icon left color="white">mdi-account-multiple</v-icon>
                  Participant Details
                  <v-spacer></v-spacer>
                  <v-btn
                    color="white"
                    text
                    small
                    @click.prevent="openNonMemberDialog"
                  >
                    <v-icon left small>mdi-plus-circle</v-icon>
                    Add Participant
                  </v-btn>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-data-table
                    :headers="tableColumns2"
                    :items="AllParticipants"
                    hide-default-footer
                    disable-sort
                    class="elevation-1"
                  >
                    <template v-slot:no-data>
                      <div class="text-center py-4">
                        <v-icon size="64" color="grey lighten-1"
                          >mdi-account-off</v-icon
                        >
                        <p class="mt-3 text-subtitle-1">
                          No participants added yet
                        </p>
                        <v-btn
                          color="primary"
                          @click.prevent="openNonMemberDialog"
                        >
                          <v-icon left>mdi-plus-circle</v-icon>
                          Add First Participant
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item, index }">
                      <v-btn
                        icon
                        color="primary"
                        @click.prevent="openNonMemberDialog"
                        small
                      >
                        <v-icon>mdi-plus-circle</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="error"
                        @click="deleteRow(1, index, item)"
                        small
                      >
                        <v-icon>mdi-delete-circle-outline</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>

              <!-- Additional Details Card -->
              <v-card
                class="info-card mb-6"
                elevation="2"
                rounded="lg"
                v-if="
                  MemberType != '' && Object.keys(selectedMember).length > 0
                "
              >
                <v-card-title class="card-header accent white--text">
                  <v-icon left color="white">mdi-account-details</v-icon>
                  Additional Details
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <label class="field-label">
                        <span class="error--text">*</span> Gender
                      </label>
                      <v-select
                        v-model="Gender"
                        :items="GenderOptions"
                        :rules="GenderRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-gender-male-female"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                      <label class="field-label">
                        <span class="error--text">*</span> Food Preference
                      </label>
                      <v-select
                        v-model="FoodPreference"
                        :items="FoodPreferenceOptions"
                        :rules="FoodPreferenceRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-food"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                      <label class="field-label">
                        <span class="error--text">*</span> T-Shirt Size
                      </label>
                      <v-select
                        v-model="TshirtSize"
                        :items="TshirtSizeOptions"
                        :rules="TshirtSizeRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-tshirt-crew"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                      <label class="field-label">
                        Senator Number (Optional)
                      </label>
                      <v-text-field
                        v-model="SenatorNumber"
                        :rules="SenatorNumberRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-account-star"
                        placeholder="Enter senator number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="3" v-if="GstFlag">
                      <label class="field-label">
                        <span class="error--text">*</span> GST Number Available?
                      </label>
                      <v-select
                        v-model="GstNumberFlag"
                        :items="GstNumberFlagOptions"
                        :rules="GstNumberFlagRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-receipt"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="3" v-if="GstNumberFlag == 1">
                      <label class="field-label">
                        <span class="error--text">*</span> GST Number
                      </label>
                      <v-text-field
                        v-model="GstNumber"
                        :rules="GstNumberRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-file-document"
                        placeholder="Enter GST number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Professional & Medical Information Card -->
              <v-card
                class="info-card mb-6"
                elevation="2"
                rounded="lg"
                v-if="
                  MemberType != '' && Object.keys(selectedMember).length > 0
                "
              >
                <v-card-title class="card-header success white--text">
                  <v-icon left color="white">mdi-briefcase-account</v-icon>
                  Professional & Medical Information
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <!-- Professional Information -->
                    <v-col cols="12">
                      <div class="section-subtitle info--text mb-4">
                        <v-icon left color="info">mdi-briefcase</v-icon>
                        <span class="font-weight-bold"
                          >Professional Details</span
                        >
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <label class="field-label">
                        <span class="error--text">*</span> Company/Organization
                        Name
                      </label>
                      <v-text-field
                        v-model="CompanyName"
                        :rules="CompanyNameRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-domain"
                        placeholder="Enter company name"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <label class="field-label">
                        <span class="error--text">*</span>
                        Section/Division/Department
                      </label>
                      <v-text-field
                        v-model="Department"
                        :rules="DepartmentRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-office-building"
                        placeholder="Enter department"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <label class="field-label">
                        <span class="error--text">*</span> Job Title
                      </label>
                      <v-text-field
                        v-model="JobTitle"
                        :rules="JobTitleRules"
                        outlined
                        dense
                        prepend-inner-icon="mdi-badge-account"
                        placeholder="Enter job title"
                      ></v-text-field>
                    </v-col>

                    <!-- Medical Information -->
                    <v-col cols="12">
                      <v-divider class="my-2"></v-divider>
                      <div class="section-subtitle error--text mb-4 mt-4">
                        <v-icon left color="error">mdi-medical-bag</v-icon>
                        <span class="font-weight-bold"
                          >Medical Information</span
                        >
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <label class="field-label">
                        <span class="error--text">*</span> Allergies
                      </label>
                      <v-textarea
                        v-model="Allergies"
                        :rules="AllergiesRules"
                        outlined
                        dense
                        rows="3"
                        prepend-inner-icon="mdi-alert-circle"
                        placeholder="Please declare any known allergies or write 'None'"
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <label class="field-label">
                        <span class="error--text">*</span> Medical Conditions
                      </label>
                      <v-textarea
                        v-model="MedicalConditions"
                        :rules="MedicalConditionsRules"
                        outlined
                        dense
                        rows="3"
                        prepend-inner-icon="mdi-hospital-box"
                        placeholder="Please declare any medical conditions or write 'None'"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Document Details Card -->
              <v-card 
                class="info-card-jci mb-6 animate-slide-up" 
                elevation="3" 
                rounded="lg"
                v-if="
                  MemberType != '' && Object.keys(selectedMember).length > 0
                "
              >
                <v-card-title class="card-header-jci-aqua white--text">
                  <v-icon left color="white">mdi-file-document-multiple</v-icon>
                  <div>
                    <div>Passport Details</div>
                    <div class="text-caption font-weight-regular mt-1" style="opacity: 0.95; line-height: 1.4;">
                      <v-icon small color="white" class="mr-1">mdi-asterisk</v-icon>
                      Passport attachment is mandatory
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#EDBE38"
                    elevation="4"
                    class="jci-add-doc-btn"
                    @click.prevent="addDocumentPrompt = true"
                  >
                    <v-icon left color="#0A0F29">mdi-plus-circle</v-icon>
                    <span style="color: #0A0F29; font-weight: 700;">Add Document</span>
                  </v-btn>
                </v-card-title>
                <v-card-text class="pa-6">
                  <!-- Important Passport Validity Note -->
                  <v-alert
                    border="left"
                    colored-border
                    color="#EDBE38"
                    elevation="1"
                    class="mb-4"
                    dense
                  >
                    <div class="d-flex align-center">
                      <v-icon color="#EDBE38" class="mr-2">mdi-information-outline</v-icon>
                      <span style="color: #0A0F29; font-weight: 500;">
                        <strong>Important:</strong> Your passport must be valid for at least six months from the event date.
                      </span>
                    </div>
                  </v-alert>

                  <!-- Loading State -->
                  <div v-if="DocumentLoadingFlag" class="text-center py-4">
                    <v-progress-circular
                      indeterminate
                      color="#0097D7"
                      size="40"
                    ></v-progress-circular>
                  </div>

                  <!-- No Documents -->
                  <v-alert
                    v-if="!DocumentLoadingFlag && DocumentData.length === 0"
                    border="left"
                    colored-border
                    color="#EDBE38"
                    elevation="1"
                  >
                    <div class="d-flex align-center">
                      <v-icon class="mr-2" color="#EDBE38">mdi-alert-circle-outline</v-icon>
                      <span style="color: #0A0F29;"
                        >No documents added yet. Please add your documents
                        (Passport, ID proof, etc.)</span
                      >
                    </div>
                  </v-alert>

                  <!-- Document List -->
                  <v-container
                    class="py-0"
                    v-if="!DocumentLoadingFlag && DocumentData.length > 0"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                        lg="4"
                        v-for="(item, index) in DocumentData"
                        :key="index"
                      >
                        <v-card class="document-card-jci animate-hover" outlined hover>
                          <v-card-text class="pa-3">
                            <div class="d-flex align-start">
                              <v-avatar size="70" tile rounded class="mr-3">
                                <v-img
                                  :src="item.ImagePath"
                                  :alt="item.DocumentName"
                                  contain
                                >
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height ma-0"
                                      align="center"
                                      justify="center"
                                    >
                                      <v-icon>mdi-file-image</v-icon>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-avatar>
                              <div class="flex-grow-1">
                                <div
                                  class="d-flex align-center justify-space-between mb-1"
                                >
                                  <h4 class="document-title mb-0">
                                    {{ item.DocumentName }}
                                  </h4>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        x-small
                                        color="error"
                                        @click="deleteDocumentAlert(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small>mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Delete Document</span>
                                  </v-tooltip>
                                </div>
                                <div class="text-caption text--secondary mb-1">
                                  {{ item.ReferenceNo }}
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>

              <!-- Total Participants Display -->
              <v-row class="mb-6" v-if="MemberType != ''">
                <v-col cols="12" class="text-center">
                  <v-card class="info-card" elevation="2" rounded="lg">
                    <v-card-text class="pa-6">
                      <v-icon size="48" color="primary" class="mb-2"
                        >mdi-account-group</v-icon
                      >
                      <h2 class="primary--text mb-2">
                        Total Participants: {{ Qty }}
                      </h2>
                      <v-text-field
                        v-model="Qty"
                        outlined
                        dense
                        v-if="QtyFlag"
                        class="mt-3"
                        style="max-width: 200px; margin: 0 auto"
                      ></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Plan Preview Dialog -->
              <v-dialog v-model="PreviewPlanFlag" max-width="600">
                <event-plan-details
                  :Plan="PreviewPlanDetails"
                  @hideDialog="hidePreviewPlanPopup($event)"
                  v-if="PreviewPlanFlag"
                ></event-plan-details>
              </v-dialog>

              <!-- Add Document Dialog -->
              <v-dialog v-model="addDocumentPrompt" persistent max-width="800">
                <add-new-document
                  pageDescription="Add New Document"
                  aspacFlag="true"
                  :addRecordPrompt="addDocumentPrompt"
                  :MemberId="selectedMember.MemberId"
                  @hideAddRecordPrompt="handleDocumentAdded($event)"
                  v-if="addDocumentPrompt"
                ></add-new-document>
              </v-dialog>

              <!-- Add Non-Member Dialog -->
              <v-dialog
                v-model="addNonMemberRecordPrompt"
                persistent
                max-width="800"
              >
                <add-non-member
                  pageTitle="Add Participant details"
                  pageDescription="Add non member details"
                  :showDialog="addNonMemberRecordPrompt"
                  @hideDialog="addNewNonMember($event)"
                  v-if="addNonMemberRecordPrompt"
                ></add-non-member>
              </v-dialog>

              <!-- Pricing Plans Section -->
              <div class="plans-section-jci animate-fade-in" v-if="MemberType != ''">
                <div class="text-center mb-6">
                  <h2 class="section-title-jci">
                    <v-icon large color="#3A67B1" class="mr-2"
                      >mdi-ticket-percent</v-icon
                    >
                    <span style="color: #0A0F29;">Choose Your Plan</span>
                  </h2>
                  <p class="section-subtitle-jci" style="color: #414042;">
                    Select the best plan that fits your needs
                  </p>
                </div>

                <v-row justify="center">
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    v-for="(item, index) in Plans"
                    :key="index"
                  >
                    <div v-if="item.PlanVisibleFlag">
                      <!-- Popular/Recommended Plan -->
                      <div v-if="item.Recommended" class="plan-card-wrapper animate-scale-up">
                        <div class="plan-card-jci popular-plan-jci elevation-8">
                          <div class="popular-badge-jci">
                            <v-chip color="#56BDA3" text-color="white" small>
                              <v-icon left small>mdi-star</v-icon>
                              Most Popular
                            </v-chip>
                          </div>

                          <div class="plan-header-jci">
                            <h3 class="plan-title-jci white--text">
                              {{ item.PlanName }}
                            </h3>
                          </div>

                          <div class="plan-body-jci">
                            <div class="plan-price-jci">
                              <div class="price-amount-jci">
                                {{ item.TotalAmountTxt }}
                              </div>
                              <div class="price-period-jci">per head</div>
                            </div>

                            <v-divider class="mb-4"></v-divider>

                            <!-- Action Buttons -->
                            <div class="mt-auto">
                              <v-btn
                                color="#3A67B1"
                                text
                                block
                                large
                                class="mb-3 view-details-btn-jci"
                                @click.prevent="showPreviewPlanPopup(item)"
                              >
                                <v-icon left size="20" color="#3A67B1"
                                  >mdi-information-outline</v-icon
                                >
                                <span style="color: #3A67B1;">View Details</span>
                              </v-btn>

                              <v-btn
                                color="#3A67B1"
                                block
                                x-large
                                elevation="2"
                                :disabled="!valid1"
                                :loading="SubmitFlag"
                                @click.prevent="confirmAlert(item)"
                                class="select-plan-btn-jci jci-btn-navy"
                              >
                                <v-icon left size="22" color="white"
                                  >mdi-check-circle-outline</v-icon
                                >
                                <span style="color: white;">Select This Plan</span>
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Regular Plan -->
                      <div v-else class="plan-card-wrapper animate-scale-up">
                        <div class="plan-card-jci elevation-4">
                          <div class="plan-header-jci-aqua">
                            <h3 class="plan-title-jci white--text">
                              {{ item.PlanName }}
                            </h3>
                            <p
                              class="plan-subtitle-jci white--text"
                              v-if="item.PlanDescription"
                            >
                              {{ item.PlanDescription }}
                            </p>
                          </div>

                          <div class="plan-body-jci">
                            <div class="plan-price-jci">
                              <div class="price-amount-jci" style="color: #0097D7;">
                                {{ item.TotalAmountTxt }}
                              </div>
                              <div class="price-period-jci">per head</div>
                            </div>

                            <v-divider class="mb-4"></v-divider>

                            <!-- Action Buttons -->
                            <div class="mt-auto">
                              <v-btn
                                color="#0097D7"
                                text
                                block
                                large
                                class="mb-3 view-details-btn-jci"
                                @click.prevent="showPreviewPlanPopup(item)"
                              >
                                <v-icon left size="20" color="#0097D7"
                                  >mdi-information-outline</v-icon
                                >
                                <span style="color: #0097D7;">View Details</span>
                              </v-btn>

                              <v-btn
                                color="#0097D7"
                                block
                                x-large
                                elevation="2"
                                :disabled="!valid1"
                                :loading="SubmitFlag"
                                @click.prevent="confirmAlert(item)"
                                class="select-plan-btn-jci jci-btn-aqua"
                              >
                                <v-icon left size="22" color="white"
                                  >mdi-check-circle-outline</v-icon
                                >
                                <span style="color: white;">Select This Plan</span>
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AddNonMember from "@/view/pages/erp/events/aspac/AddNonMember.vue";
import EventPlanDetails from "@/view/pages/erp/events/natcon/EventPlanDetails.vue";
import AddNewDocument from "@/view/pages/profile/my-profile/AddNewDocument";

export default {
  mixins: [common],
  components: {
    AddNonMember,
    EventPlanDetails,
    AddNewDocument,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      ProgressLoadingFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      NotesFlag: false,
      rows: [],
      tableColumns1: [],

      PreviewPlanFlag: false,
      PreviewPlanDetails: {},

      addDocumentPrompt: false,
      DocumentLoadingFlag: false,
      DocumentData: [],
      selectedDocument: {},

      GstFlag: false,

      selected: [],
      search: "",

      MemberPaymentLink: "",
      RegisterDetailsTxt: "Member Details",

      RegistrationTypeId: "",

      Qty: "",
      QtyFlag: false,
      QtyRules: [
        (v) => Number.isInteger(Number(v)) || "Nos is invalid",
        (v) => v > 0 || "Number must be greater than zero",
        (v) => v < 7 || "Number must be less than 6",
      ],

      MemberType: "",
      MemberTypeRules: [(v) => !!v || "Member Type for is required"],
      MemberTypeOptions: [],

      Lom: {},

      Member: {},

      Presidentmember: {},
      Plans: [],

      selectedPlan: {},
      selectedMember: {},

      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      Events: {},

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      CheckoutTableHeaders: [],

      tab: null,
      TabDisable1: false,
      TabDisable2: false,

      TotalAmount: 0,
      Contribution: [],

      TotalAmount1: 0,
      TotalAmount2: 0,

      Member: {},
      Order: {},
      MemberImageFlag: false,

      PenaltySubscription: [],

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      OrderType: 1,

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      GstNumberFlag: 2,
      GstNumberFlagRules: [
        (v) => !!v || "Does your LO has GST number field required",
      ],
      GstNumberFlagOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Yes" },
        { value: 2, text: "No" },
      ],

      GstNumber: "",
      GstNumberRules: [(v) => !!v || "GST number is required"],

      TshirtSize: "",
      TshirtSizeRules: [(v) => !!v || "T-Shirt size is required"],
      TshirtSizeOptions: [
        { value: "", text: "--Select--" },
        { value: "S", text: "S" },
        { value: "M", text: "M" },
        { value: "L", text: "L" },
        { value: "XL", text: "XL" },
        { value: "XXL", text: "XXL" },
        { value: "3XL", text: "3XL" },
        { value: "4XL", text: "4XL" },
        { value: "5XL", text: "5XL" },
      ],

      SenatorNumber: "",
      SenatorNumberRules: [],

      Gender: "",
      GenderRules: [(v) => !!v || "Gender is required"],
      GenderOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        { value: 3, text: "Other" },
      ],

      FoodPreference: "",
      FoodPreferenceRules: [(v) => !!v || "Food preference is required"],
      FoodPreferenceOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Vegan (Veg)" },
        { value: 2, text: "Non Veg" },
      ],

      CompanyName: "",
      CompanyNameRules: [(v) => !!v || "Company/Organization name is required"],

      Department: "",
      DepartmentRules: [
        (v) => !!v || "Section/Division/Department is required",
      ],

      JobTitle: "",
      JobTitleRules: [(v) => !!v || "Job title is required"],

      Allergies: "",
      AllergiesRules: [
        (v) => !!v || "Please declare any known allergies or write 'None'",
      ],

      MedicalConditions: "",
      MedicalConditionsRules: [
        (v) => !!v || "Please declare any medical conditions or write 'None'",
      ],

      ZoneCode: "",
      LomCode: "",
      EventId: 12,
      EventTypeId: 14,

      MemberId: "",
      UserMemberId: "",

      addNonMemberRecordPrompt: false,
      ParticipantMaxLimit: 6,
      AllParticipants: [],
      NonMemberDetails: {},
      uploadedParticipantImages: [],
      tableColumns2: [
        { text: "Participant Name", value: "ParticipantName" },
        { text: "Gender", value: "Gender" },
        { text: "Age", value: "Age" },
        { text: "Mobile number", value: "MobileNo" },
        { text: "Email Id", value: "EmailId" },
        { text: "Action", value: "action" },
      ],

      Order: {
        back_url: "",
        customer_name: "",
        customer_email_id: "",
        customer_mobile_no: "",
        rzp_action: "#",
        rzp_account_id: "",
        rzp_key: "bdgzbd",
        rzp_amount: "",
        rzp_order_id: "",
        rzp_buttontext: "Pay now",
        rzp_name: "JCI India Foundation",
        rzp_description: "",
        rzp_image: "",
        rzp_color: "#0096d5",
      },

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      RoleId: "",
    };
  },
  computed: {},
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var UserMemberId = this.$session.get("MemberId");
        this.UserMemberId = UserMemberId;
        console.log({ UserMemberId });

        var ZoneId = this.$session.get("ZoneId");
        this.ZoneCode = ZoneId;
        console.log({ ZoneId });

        var LomId = this.$session.get("LomId");
        this.LomCode = LomId;
        console.log({ LomId });

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        console.log({ RoleId });
        this.RoleId = RoleId;
        var MemberPaymentLink =
          RoleId == 9
            ? "/natcon/payment/create"
            : "/natcon/member-payment/create";
        console.log({ MemberPaymentLink });
        this.MemberPaymentLink = MemberPaymentLink;

        if (RoleId == 9) {
          var MemberTypeOptions = [
            { value: "", text: "--Select Type--" },
            { value: 2, text: "For another member" },
            { value: 3, text: "For non member" },
          ];
        } else {
          var MemberTypeOptions = [
            { value: "", text: "--Select Type--" },
            { value: 1, text: "For me" },
            // { value: 2, text: "For another member" },
            // { value: 3, text: "For non member" },
          ];
        }
        console.log({ MemberTypeOptions });
        this.MemberTypeOptions = MemberTypeOptions;

        this.pageData();
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    Qty: function () {
      console.log("watch Qty");
      var Qty = this.Qty;
      Qty = Qty == (null || undefined || isNaN(Qty)) ? 0 : parseFloat(Qty);
      console.log({ Qty });
      var Plans = this.Plans;
      console.log({ Plans });
      var newPlans = [];
      Plans.forEach((item) => {
        console.log({ item });
        var temp = item;
        var Amount = parseFloat(item.SubTotal);
        console.log({ Amount });
        var TotalAmount = Qty * Amount;
        TotalAmount =
          TotalAmount == (null || undefined || isNaN(TotalAmount))
            ? 0
            : parseFloat(TotalAmount);
        console.log({ TotalAmount });
        temp.Qty = Qty;
        temp.TotalAmount = TotalAmount;
        newPlans.push(temp);
      });
      this.Plans = newPlans;
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
    },
    MemberType: function () {
      console.log("watch MemberType");
      this.selectedMember = {};
      var MemberType = this.MemberType;
      console.log("MemberType=" + MemberType);
      if (MemberType != "") {
        this.AllParticipants = [];
        this.Qty = 0;
        var Member = this.Member;
        console.log({ Member });
        var MemberId = Member.MemberId;
        console.log({ MemberId });
        var tempData = {
          MemberFlag: true,
          MemberId: MemberId,
          MembershipId: Member.MembershipId,
          MemberName: Member.Fullname,
          Gender: "",
          Age: "",
          MobileNo: Member.MobileNo,
          EmailId: Member.EmailId,
          MemberImagePath: Member.MemberImage,
          action: "",
        };
        console.log({ tempData });
        if (MemberType == 1) {
          this.RegisterDetailsTxt = "Member Details";
          // this.AllParticipants.push(tempData);
          this.selectedMember = tempData;
          this.Qty = 1;
          this.MemberId = MemberId;
        } else if (MemberType == 2) {
          this.MemberId = "";
          this.RegisterDetailsTxt = "Member Details";
          this.getSelectedMemberDetails();
        } else {
          this.RegisterDetailsTxt = "Payee Details";
          this.selectedMember = tempData;
          this.MemberId = MemberId;
        }
      }
    },
  },
  methods: {
    goBack() {
      console.log("goBack called");
      this.$router.go(-1);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var id = this.$route.query.id;
      console.log({ id });
      this.EventId = id;
      var url1 = "api/jci-program/show";
      var condition1 = {
        UserInterface: 1,
        Program: id,
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getMemberDetails();
      this.getMemberIdOptions();
      this.getEventsDetails();
      this.getDocumentDetails();
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/staff/list";
      var params = {};
      this.pageRedirect(params, url);
    },
    resetForm() {
      this.$refs.form2.reset();
      this.selectedMember = {};
      this.selectedPlan = {};
      // this.refreshPageData();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    openNonMemberDialog() {
      console.log("openNonMemberDialog called");
      var n2 = this.AllParticipants.length;
      console.log({ n2 });
      var m2 = this.ParticipantMaxLimit;
      console.log({ m2 });
      if (n2 < m2) {
        this.addNonMemberRecordPrompt = true;
      } else {
        var message = "Participant maximum limit " + m2 + " reached. ";
        this.sweetAlert("error", message, false);
      }
    },
    showPreviewPlanPopup(tr) {
      this.PreviewPlanDetails = tr;
      this.PreviewPlanFlag = true;
    },
    hidePreviewPlanPopup() {
      this.PreviewPlanDetails = {};
      this.PreviewPlanFlag = false;
    },
    setQty() {
      console.log("setQty called");
      var n3 = this.AllParticipants.length;
      console.log({ n3 });
      this.Qty = n3;
    },
    addNewNonMember(member) {
      console.log("addNewNonMember called");
      this.addNonMemberRecordPrompt = false;
      console.log({ member });
      this.NonMemberDetails = member;
      this.addNewRow(1);
    },
    addNewRow(tableId) {
      console.log("addNewRow called");

      console.log("tableId=" + tableId);

      switch (tableId) {
        case 1:
          var n2 = this.AllParticipants.length;
          console.log({ n2 });
          var MemberFlag = this.NonMemberDetails.MemberFlag;
          MemberFlag = MemberFlag == (null || undefined) ? false : MemberFlag;
          console.log({ MemberFlag });
          var m2 = this.ParticipantMaxLimit;
          console.log({ m2 });
          if (n2 < m2) {
            if (MemberFlag) {
              this.AllParticipants.push(this.NonMemberDetails);
              this.setQty();
            }
          } else {
            var message = "Participant maximum limit " + m2 + " reached. ";
            this.sweetAlert("error", message, false);
          }
          this.NonMemberDetails = {};
          break;

        default:
          break;
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log({ tableId });
      console.log({ index });
      console.log({ tr });
      if (index >= 0) {
        switch (tableId) {
          case 1:
            this.AllParticipants.splice(index, 1);
            this.setQty();
            break;

          default:
            break;
        }
      }
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      var RoleId = this.RoleId;
      console.log({ RoleId });
      var SmaRoles = [5];
      var SmaFlag = SmaRoles.includes(RoleId);
      console.log({ SmaFlag });
      var UserInterface = SmaFlag ? 3 : 2;
      // var UserInterface = 2;
      console.log({ UserInterface });
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: UserInterface,
        LomCode: this.LomCode,
        MemberType: 1,
        ZoneCode: this.ZoneCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getDocumentDetails() {
      console.log("getDocumentDetails called");

      var memberId = this.selectedMember.MemberId;
      console.log({ memberId });

      var MemberId = memberId > 0 ? memberId : this.UserMemberId;
      console.log({ MemberId });

      if (MemberId == "" || !MemberId) {
        console.log("No MemberId available");
        return;
      }

      this.DocumentLoadingFlag = true;
      this.DocumentData = [];

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/members-document-details/show";
      var upload = {
        UserInterface: 2,
        MemberId: MemberId,
      };

      console.log("upload=" + JSON.stringify(upload));

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.DocumentLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);

          if (flag == 1) {
            thisIns.DocumentData = records.TableData || [];
            console.log(thisIns.DocumentData);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.DocumentLoadingFlag = false;
        });
    },
    handleDocumentAdded(flag) {
      console.log("handleDocumentAdded called, flag=" + flag);
      this.addDocumentPrompt = false;
      if (flag) {
        this.getDocumentDetails();
        this.toast("success", "Document added successfully");
      }
    },
    deleteDocumentAlert(tr) {
      console.log("deleteDocumentAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedDocument = tr;
        this.confirmDeleteDocument();
      } else {
        this.toast("error", "Kindly select one document to delete");
      }
    },
    confirmDeleteDocument() {
      console.log("confirmDeleteDocument called");
      var tr = this.selectedDocument;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var htmlTxt = "";
        htmlTxt += "Document name <b> " + tr.DocumentName + "</b>";
        htmlTxt += "<br/> Reference No <b> " + tr.ReferenceNo + "</b>";
        htmlTxt +=
          "<br/><img width='100' height='100' src='" + tr.ImagePath + "' />";
        htmlTxt += "<br/><br/>Do you want to delete this document?";
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete this document?",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteDocument();
          } else {
            this.toast("error", "You cancelled the process");
          }
        });
      } else {
        this.toast("error", "Kindly select one document to delete");
      }
    },
    deleteDocument() {
      console.log("deleteDocument called");

      var tr = this.selectedDocument;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.DocumentLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members-document-details/destroy";
        var upload = {
          UserInterface: 1,
          Member: tr.MemberId,
          Document: tr.DocumentId,
        };
        console.log("upload=" + JSON.stringify(upload));

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.DocumentLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.selectedDocument = {};
              thisIns.getDocumentDetails();
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.DocumentLoadingFlag = false;
          });
      } else {
        this.toast("error", "Kindly select one document to delete");
      }
    },
    getSelectedMemberDetails() {
      console.log("getSelectedMemberDetails called");
      this.selectedMember = {};
      this.AllParticipants = [];
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx > 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        var tempData = {
          MemberFlag: true,
          MemberId: member.value,
          MembershipId: member.membership_id,
          MemberName: member.member_name,
          Gender: "",
          Age: "",
          MobileNo: member.mobile_no || "",
          EmailId: member.email_id || "",
          MemberImagePath: member.photo,
          action: "",
        };
        // this.AllParticipants.push(tempData);
        this.selectedMember = tempData;
        this.Qty = 1;
        this.getDocumentDetails();
      } else {
        this.Qty = 0;
      }
    },
    getMemberDetails() {
      console.log("getMemberDetails is called");

      var MemberId = this.UserMemberId;
      var ZoneCode = this.ZoneCode;
      var LomCode = this.LomCode;
      console.log(
        "MemberId=" +
          MemberId +
          "; ZoneCode=" +
          ZoneCode +
          "; LomCode=" +
          LomCode
      );

      if (MemberId != "" && ZoneCode != "" && LomCode != "") {
        this.LoadingFlag = true;
        this.Member = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/search";
        var upload = {
          UserInterface: 4,
          MemberId: MemberId,
          ZoneCode: ZoneCode,
          LomCode: LomCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.Member = records;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "";
        if (MemberId == "" || ZoneCode == "" || LomCode == "") {
          message += "Your session is expired. Kindly login again. ";
        }
        this.toast("error", message);
      }
    },
    getEventsDetails() {
      console.log("getEventsDetails is called");

      var EventId = this.EventId;
      console.log("EventId=" + EventId);

      if (EventId != "") {
        this.SubmitFlag = true;
        this.StartupLoadingFlag = true;

        this.Plans = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/plan/lists";
        var upload = {
          UserInterface: 2,
          Program: EventId,
          ProgramType: this.EventTypeId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.Plans = records.TableData;
              // thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        if (EventId == "") {
          message += "Event id should not be empty";
        }
        this.toast("error", message);
      }
    },
    confirmAlert(selectedPlan) {
      console.log("confirmAlert called");

      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var selectedMember = this.selectedMember;
      console.log({ selectedMember });

      var MemberType = this.MemberType;
      console.log({ MemberType });

      var RegistrationTypeId = MemberType <= 2 ? 3 : 4;
      console.log({ RegistrationTypeId });

      var MemberId = selectedMember.MemberId;
      MemberId = MemberId == (null || undefined) ? "" : MemberId;
      console.log({ MemberId });

      this.selectedPlan = selectedPlan;
      console.log({ selectedPlan });

      var EventPlanId = selectedPlan.EventPlanId;
      EventPlanId = EventPlanId == (null || undefined) ? "" : EventPlanId;
      console.log({ EventPlanId });

      var participants = this.AllParticipants;
      console.log({ participants });

      var TotalCount = this.Qty;
      console.log("TotalCount=" + TotalCount);

      var EventTotalAmount = selectedPlan.SubTotal;
      console.log("EventTotalAmount=" + EventTotalAmount);

      var TotalAmount = parseFloat(TotalCount) * parseFloat(EventTotalAmount);
      console.log("TotalAmount=" + TotalAmount);

      if (validate1 && TotalCount > 0 && TotalAmount > 0 && MemberType > 0) {
        this.RegistrationTypeId = RegistrationTypeId;

        var MemberTxt = "";
        participants.forEach((item) => {
          console.log({ item });
          MemberTxt +=
            "<br/>" +
            item.ParticipantName +
            " &nbsp; - " +
            item.MobileNo +
            " &nbsp; - " +
            item.EmailId;
        });
        var htmlTxt = "";
        htmlTxt += "<br/><b>Selected plan details</b>";
        htmlTxt += "<br/>Plan name <b>" + selectedPlan.PlanName + "</b>";
        htmlTxt += "<br/><br/><b>Selected participant details</b>";

        if (RegistrationTypeId == 3) {
          htmlTxt +=
            "<br/>Member Name <b>" + selectedMember.MemberName + "</b>";
          htmlTxt += "<br/>Mobile no. <b>" + selectedMember.MobileNo + "</b>";
          htmlTxt += "<br/>Email id <b>" + selectedMember.EmailId + "</b>";
          htmlTxt +=
            "<br/><img width='100' height='100' src='" +
            selectedMember.MemberImagePath +
            "' />";
        } else {
          htmlTxt +=
            "<br/><b> Member Name &nbsp; - Mobile no. &nbsp; - Email id </b>";
          htmlTxt += MemberTxt;
        }

        htmlTxt += "<br/><br/>Total amount <b> ₹ " + TotalAmount + "</b>";
        htmlTxt += "<br/><br/>Do you want to continue?";
        Swal.fire({
          title: "Please verify all the information before proceeding",
          text: "",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
            // this.makePayment();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (MemberId == "") {
          message += "Kindly select member. ";
        }
        if (EventPlanId == "") {
          message += "Kindly select plan. ";
        }
        if (TotalCount == 0) {
          message += "Kindly add atleast one participant. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var selectedPlan = this.selectedPlan;
      console.log({ selectedPlan });

      var selectedMember = this.selectedMember;
      console.log({ selectedMember });

      var RegistrationTypeId = this.RegistrationTypeId;
      console.log({ RegistrationTypeId });

      var MemberId = selectedMember.MemberId;
      MemberId = MemberId == (null || undefined) ? "" : MemberId;
      console.log({ MemberId });

      var EventPlanId = selectedPlan.EventPlanId;
      EventPlanId = EventPlanId == (null || undefined) ? "" : EventPlanId;
      console.log({ EventPlanId });

      var participants = this.AllParticipants;
      console.log({ participants });

      var TotalCount = this.Qty;
      console.log("TotalCount=" + TotalCount);

      var EventTotalAmount = selectedPlan.TotalAmount;
      console.log("EventTotalAmount=" + EventTotalAmount);

      var TotalAmount = parseFloat(TotalCount) * parseFloat(EventTotalAmount);
      console.log("TotalAmount=" + TotalAmount);

      if (
        validate1 &&
        TotalCount > 0 &&
        TotalAmount > 0 &&
        RegistrationTypeId > 0
      ) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/order/create";
        var upload = {
          UserInterface: RegistrationTypeId,
          RegistrationType: RegistrationTypeId,
          Lom: this.LomCode,
          Member: MemberId,
          Event: this.EventId,
          Plan: EventPlanId,
          MobileNo: selectedMember.MobileNo,
          EmailId: selectedMember.EmailId,
          Gender: this.Gender,
          FoodPreference: this.FoodPreference,
          GstNumberFlag: this.GstNumberFlag,
          GstNumber: this.GstNumberFlag == 1 ? this.GstNumber : null,
          TshirtSize: this.TshirtSize,
          SenatorNumber: this.SenatorNumber,
          CompanyName: this.CompanyName,
          Department: this.Department,
          JobTitle: this.JobTitle,
          Allergies: this.Allergies,
          MedicalConditions: this.MedicalConditions,
          TotalCount: TotalCount,
          TotalAmount: TotalAmount,
          Participants: participants,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.SubmitFlag = true;
        this.ProgressLoadingFlag = true;

        // this.$session.set("checkout", upload);
        // this.checkout();

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.ProgressLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              /*
              thisIns.sweetAlert(
                "info",
                "You will be redirected to checkout page shortly",
                true
              );
              */
              thisIns.Order = records.Order;
              thisIns.makePayment();
            } else {
              // thisIns.toast("error", output);
              // thisIns.Order = records.Order;
              // thisIns.makePayment();
              thisIns.sweetAlert("info", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.ProgressLoadingFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalCount == 0) {
          message += "Kindly add atleast one participant. ";
        }
        if (TotalAmount == 0) {
          message += "Kindly select a plan. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    makePayment() {
      console.log("makePayment");
      // ev.preventDefault();
      var order = this.Order;
      const thisIns = this;
      var rzp1 = new Razorpay({
        key: order.rzp_key,
        account_id: order.rzp_account_id,
        order_id: order.rzp_order_id,
        amount: order.rzp_amount,
        name: order.rzp_name,
        currency: "INR",
        description: order.rzp_description,
        image: order.rzp_image,
        theme: {
          color: order.rzp_color,
        },
        prefill: {
          name: order.customer_name,
          email: order.customer_email_id,
          contact: order.customer_mobile_no,
        },
        notes: {
          address: "",
        },
        // callback_url: "http://domain.com/#/about/" + this.order_id,
        redirect: false,
        handler: function (response) {
          console.log("razorpay_payment_id=" + response.razorpay_payment_id);
          thisIns.SubmitFlag = true;
          // thisIns.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
          thisIns.pageRedirect({}, "/order/success");
        },
      });
      rzp1.open();
    },
  },
  beforeMount() {
    this.refreshPageData();
    /*
    this.tableColumns1.push(
      { text: "Description", value: "Description" },
      { text: "Subscription Fees", value: "AmountTxt" },
      { text: "Nos", value: "Qty" },
      { text: "Sub Total", value: "SubTotal" }
      // { text: "Actions", value: "actions" }
    );
    */
  },
};
</script>
<style lang="scss" scoped>
// JCI Brand Colors
$jci-aqua: #0097D7;
$jci-navy: #3A67B1;
$jci-gold: #EDBE38;
$jci-seafoam: #56BDA3;
$jci-black-90: #414042;
$jci-black-off: #0A0F29;
$jci-white: #ffffff;

#sma-natcon-payment-create {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  min-height: 100vh;
  padding: 20px 0;

  // Hero Section with JCI Branding
  .hero-card {
    background: transparent !important;
    margin-bottom: 30px;
  }

  .hero-gradient-jci {
    background: linear-gradient(135deg, $jci-navy 0%, $jci-aqua 100%);
    border-radius: 20px;
    box-shadow: 0 12px 48px rgba(58, 103, 177, 0.35);
    position: relative;
    overflow: hidden;
    padding: 0;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.12) 1px,
        transparent 1px
      );
      background-size: 50px 50px;
      animation: backgroundMove 20s linear infinite;
    }
  }

  @keyframes backgroundMove {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(50px, 50px);
    }
  }

  .hero-icon-box-jci {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 18px;
    padding: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(12px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, rgba(237, 190, 56, 0.2) 0%, rgba(0, 151, 215, 0.2) 100%);
      opacity: 0;
      transition: opacity 0.4s ease;
    }

    &:hover {
      transform: scale(1.08) rotate(2deg);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);

      &::before {
        opacity: 1;
      }

      .hero-icon-animated {
        animation: iconPulse 0.6s ease-in-out;
      }
    }
  }

  // Hero Icon Animation
  .hero-icon-animated {
    animation: iconFloat 3s ease-in-out infinite, iconGlow 2s ease-in-out infinite;
    filter: drop-shadow(0 0 8px rgba(237, 190, 56, 0.4));
  }

  @keyframes iconFloat {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
    }
    25% {
      transform: translateY(-8px) rotate(-5deg);
    }
    50% {
      transform: translateY(0) rotate(0deg);
    }
    75% {
      transform: translateY(-4px) rotate(3deg);
    }
  }

  @keyframes iconGlow {
    0%, 100% {
      filter: drop-shadow(0 0 8px rgba(237, 190, 56, 0.4));
    }
    50% {
      filter: drop-shadow(0 0 16px rgba(237, 190, 56, 0.8)) drop-shadow(0 0 24px rgba(0, 151, 215, 0.4));
    }
  }

  @keyframes iconPulse {
    0%, 100% {
      transform: scale(1) rotate(0deg);
    }
    25% {
      transform: scale(1.15) rotate(-10deg);
    }
    75% {
      transform: scale(1.15) rotate(10deg);
    }
  }

  .hero-title-jci {
    font-size: 2rem;
    font-weight: 800;
    text-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
    letter-spacing: -0.5px;
    line-height: 1.2;
  }

  .hero-subtitle-jci {
    font-size: 1.05rem;
    font-weight: 400;
    opacity: 0.95;
    text-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    line-height: 1.5;
  }

  .hero-action-btn-jci {
    font-weight: 700;
    letter-spacing: 0.5px;
    border-radius: 12px !important;
    padding: 14px 36px !important;
    height: 52px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 16px rgba(237, 190, 56, 0.4);

    &:hover {
      transform: translateY(-3px) scale(1.02);
      box-shadow: 0 8px 24px rgba(237, 190, 56, 0.5);
    }
  }

  // JCI Alert Styling
  .jci-alert {
    border-radius: 12px;
    animation: slideInDown 0.5s ease-out;
  }

  @keyframes slideInDown {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  // Main Card with JCI Styling
  .main-card-jci {
    background: white;
    border-radius: 18px;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(58, 103, 177, 0.1);
  }

  .required-note-jci {
    display: flex;
    align-items: center;
    color: $jci-black-90;
    font-size: 0.875rem;
    padding: 8px 12px;
    background: rgba(237, 190, 56, 0.08);
    border-radius: 8px;
  }

  // Info Cards with JCI Colors
  .info-card-jci {
    border-radius: 14px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid transparent;
    background: white;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 18px 45px rgba(0, 0, 0, 0.18);
      border-color: rgba(0, 151, 215, 0.3);
    }

    .card-header-jci-navy {
      padding: 18px 24px;
      border-radius: 14px 14px 0 0;
      font-size: 1.15rem;
      background: linear-gradient(135deg, $jci-navy 0%, darken($jci-navy, 8%) 100%);
      box-shadow: 0 4px 12px rgba(58, 103, 177, 0.25);
    }

    .card-header-jci-aqua {
      padding: 18px 24px;
      border-radius: 14px 14px 0 0;
      font-size: 1.15rem;
      background: linear-gradient(135deg, $jci-aqua 0%, darken($jci-aqua, 8%) 100%);
      box-shadow: 0 4px 12px rgba(0, 151, 215, 0.25);
    }

    .card-header-jci-seafoam {
      padding: 18px 24px;
      border-radius: 14px 14px 0 0;
      font-size: 1.15rem;
      background: linear-gradient(135deg, $jci-seafoam 0%, darken($jci-seafoam, 8%) 100%);
      box-shadow: 0 4px 12px rgba(86, 189, 163, 0.25);
    }

    .card-header-jci-gold {
      padding: 18px 24px;
      border-radius: 14px 14px 0 0;
      font-size: 1.15rem;
      background: linear-gradient(135deg, $jci-gold 0%, darken($jci-gold, 5%) 100%);
      box-shadow: 0 4px 12px rgba(237, 190, 56, 0.3);
    }
  }

  // JCI Button Styles
  .jci-btn {
    font-weight: 600;
    letter-spacing: 0.3px;
    text-transform: none;
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
    }

    &.jci-btn-aqua {
      background: linear-gradient(135deg, $jci-aqua 0%, darken($jci-aqua, 5%) 100%) !important;
    }

    &.jci-btn-navy {
      background: linear-gradient(135deg, $jci-navy 0%, darken($jci-navy, 5%) 100%) !important;
    }

    &.jci-btn-seafoam {
      background: linear-gradient(135deg, $jci-seafoam 0%, darken($jci-seafoam, 5%) 100%) !important;
    }

    &.jci-btn-dark {
      background: linear-gradient(135deg, $jci-black-90 0%, $jci-black-off 100%) !important;
    }
  }

  .jci-btn-text-white {
    &:hover {
      background-color: rgba(255, 255, 255, 0.15) !important;
    }
  }

  // Add Document Button - Distinct JCI Gold styling
  .jci-add-doc-btn {
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: none;
    border-radius: 10px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 16px rgba(237, 190, 56, 0.5) !important;
    padding: 8px 24px !important;

    &:hover {
      transform: translateY(-2px) scale(1.03);
      box-shadow: 0 8px 24px rgba(237, 190, 56, 0.6) !important;
      background-color: darken(#EDBE38, 5%) !important;
    }

    .v-icon {
      transition: transform 0.3s ease;
    }

    &:hover .v-icon {
      transform: rotate(90deg) scale(1.1);
    }
  }

  // Section Subtitles
  .section-subtitle-jci {
    display: flex;
    align-items: center;
    color: $jci-black-off;
    padding: 10px 14px;
    background: rgba(0, 151, 215, 0.05);
    border-radius: 10px;
    border-left: 4px solid $jci-aqua;
  }

  // Document Card JCI
  .document-card-jci {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 14px !important;
    border: 2px solid rgba(0, 151, 215, 0.1);

    &:hover {
      transform: translateY(-6px) scale(1.02);
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18) !important;
      border-color: $jci-aqua;
    }
  }

  .document-title {
    font-size: 14px;
    font-weight: 600;
    color: $jci-black-off;
    line-height: 1.4;
  }

  // CSS Animations
  .animate-fade-in {
    animation: fadeIn 0.6s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .animate-slide-right {
    animation: slideRight 0.6s ease-out;
  }

  @keyframes slideRight {
    from {
      transform: translateX(-30px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .animate-slide-left {
    animation: slideLeft 0.6s ease-out;
  }

  @keyframes slideLeft {
    from {
      transform: translateX(30px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .animate-slide-up {
    animation: slideUp 0.6s ease-out;
  }

  @keyframes slideUp {
    from {
      transform: translateY(30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .animate-scale-up {
    animation: scaleUp 0.5s ease-out;
  }

  @keyframes scaleUp {
    from {
      transform: scale(0.95);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  .animate-hover {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-4px) scale(1.02);
    }
  }

  // Old styles preserved
  .hero-icon {
    animation: float 3s ease-in-out infinite;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-20px);
    }
  }

  .hero-title {
    font-size: 3rem;
    font-weight: 700;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    letter-spacing: -1px;
  }

  .hero-subtitle {
    font-size: 1.25rem;
    font-weight: 400;
    opacity: 0.95;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  // Main Card
  .main-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .main-card-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px 24px !important;
    font-size: 1.25rem;
    font-weight: 600;
    letter-spacing: 0.5px;

    .header-actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .header-action-btn {
      font-weight: 500;
      letter-spacing: 0.5px;
      text-transform: none;
      transition: all 0.3s ease;
      border-radius: 8px;
      padding: 8px 16px !important;
      
      &:hover {
        background-color: rgba(255, 255, 255, 0.15) !important;
        transform: translateY(-1px);
      }

      .v-icon {
        font-size: 18px;
      }
    }

    @media (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start !important;
      gap: 12px;

      .header-actions {
        width: 100%;
        justify-content: flex-start;
      }

      .header-action-btn {
        font-size: 0.875rem;
        padding: 6px 12px !important;
      }
    }
  }

  .required-note {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 0.875rem;
  }

  // Info Cards
  .info-card {
    border-radius: 12px;
    transition: all 0.3s ease;
    border: 1px solid rgba(0, 0, 0, 0.05);

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
    }

    .card-header {
      padding: 16px 20px;
      border-radius: 12px 12px 0 0;
      font-size: 1.1rem;
      font-weight: 600;
    }

    .info-item {
      display: flex;
      align-items: center;
      margin: 8px 0;
    }
  }

  .h-100 {
    height: 100%;
  }

  .field-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #424242;
    font-size: 0.95rem;
  }

  // Plans Section JCI
  .plans-section-jci {
    margin-top: 48px;
    padding: 24px 0;
  }

  .section-title-jci {
    font-size: 2.5rem;
    font-weight: 800;
    color: $jci-black-off;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
  }

  .section-subtitle-jci {
    font-size: 1.1rem;
    color: $jci-black-90;
    margin-bottom: 0;
  }

  .plan-card-wrapper {
    height: 100%;
    margin-bottom: 24px;
  }

  .plan-card-jci {
    background: white;
    border-radius: 18px;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    height: 100%;
    min-height: 480px;
    display: flex;
    flex-direction: column;
    border: 3px solid transparent;
    position: relative;

    &:hover {
      transform: translateY(-12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
    }

    &.popular-plan-jci {
      border-color: $jci-navy;
      box-shadow: 0 15px 50px rgba(58, 103, 177, 0.25);
    }

    .popular-badge-jci {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 10;
      animation: bounceIn 0.8s ease-out;
    }

    @keyframes bounceIn {
      0% {
        transform: scale(0);
        opacity: 0;
      }
      50% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }

    @keyframes pulse {
      0%,
      100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
    }

    .plan-header-jci {
      padding: 32px 24px;
      text-align: center;
      background: linear-gradient(135deg, $jci-navy 0%, darken($jci-navy, 10%) 100%);
      position: relative;
      overflow: hidden;
    }

    .plan-header-jci-aqua {
      padding: 32px 24px;
      text-align: center;
      background: linear-gradient(135deg, $jci-aqua 0%, darken($jci-aqua, 10%) 100%);
      position: relative;
      overflow: hidden;
    }

    .plan-title-jci {
      font-size: 1.75rem;
      font-weight: 800;
      margin: 0;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .plan-subtitle-jci {
      font-size: 0.95rem;
      margin: 10px 0 0;
      opacity: 0.95;
    }

    .plan-body-jci {
      padding: 36px 24px;
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .plan-price-jci {
      text-align: center;
      margin-bottom: 24px;
    }

    .price-amount-jci {
      font-size: 3.25rem;
      font-weight: 900;
      line-height: 1;
      margin-bottom: 8px;
      background: linear-gradient(135deg, $jci-navy 0%, $jci-aqua 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .price-period-jci {
      font-size: 1rem;
      color: $jci-black-90;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 600;
    }

    // JCI Button Styles for Plans
    .view-details-btn-jci {
      font-weight: 600;
      letter-spacing: 0.3px;
      text-transform: none;
      border-radius: 12px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      padding: 14px 28px !important;
      height: 52px !important;

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
        transform: translateY(-2px);
      }

      .v-icon {
        opacity: 0.9;
        transition: all 0.3s ease;
      }

      &:hover .v-icon {
        opacity: 1;
        transform: scale(1.1);
      }
    }

    .select-plan-btn-jci {
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: none;
      border-radius: 14px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
      padding: 18px 36px !important;
      height: 60px !important;

      span {
        font-size: 1.05rem;
        letter-spacing: 0.3px;
      }

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
      }

      .v-icon {
        transition: transform 0.3s ease;
      }

      &:hover .v-icon {
        transform: scale(1.15) rotate(5deg);
      }
    }
  }

  /* Section Subtitle */
  .section-subtitle {
    display: flex;
    align-items: center;
    color: #2d3748;
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    border-left: 3px solid currentColor;
  }

  /* Textarea Styling */
  .v-textarea {
    .v-input__slot {
      border-radius: 10px !important;
    }
  }

  /* Document Card Styles */
  .document-card {
    transition: all 0.3s ease;
    border-radius: 12px !important;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
    }
  }

  .document-title {
    font-size: 14px;
    font-weight: 600;
    color: #2d3748;
    line-height: 1.4;
  }

  // Responsive Design
  @media (max-width: 960px) {
    .hero-title-jci {
      font-size: 1.6rem;
    }

    .hero-subtitle-jci {
      font-size: 0.95rem;
    }

    .hero-icon-box-jci {
      padding: 18px;

      .v-icon {
        font-size: 52px !important;
      }
    }

    .hero-action-btn-jci {
      width: 100%;
      margin-top: 16px;
      margin-right: 0 !important;
      margin-bottom: 8px;
    }

    .hero-title {
      font-size: 2rem;
    }

    .hero-subtitle {
      font-size: 1rem;
    }

    .section-title {
      font-size: 2rem;
    }

    .plan-card {
      min-height: auto;
    }
  }

  @media (max-width: 600px) {
    .hero-title-jci {
      font-size: 1.4rem;
    }

    .hero-subtitle-jci {
      font-size: 0.9rem;
    }

    .hero-icon-box-jci {
      padding: 14px;
      margin-right: 12px !important;

      .v-icon {
        font-size: 44px !important;
      }
    }

    .hero-title {
      font-size: 1.75rem;
    }

    .hero-subtitle {
      font-size: 0.95rem;
    }

    .section-title-jci {
      font-size: 1.75rem;
    }

    .plan-card-jci {
      min-height: 420px;

      .plan-title-jci {
        font-size: 1.4rem;
      }

      .plan-body-jci {
        padding: 24px 18px;
      }
    }

    .price-amount-jci {
      font-size: 2.5rem;
    }

    .jci-btn {
      font-size: 0.875rem !important;
    }

    .select-plan-btn-jci {
      height: 54px !important;
      padding: 16px 24px !important;

      span {
        font-size: 0.95rem !important;
      }
    }
  }

  // Animation Classes
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>